import React from 'react';

interface DaySelectorProps {
  value: number[];
  onChange: (days: number[]) => void;
  disabled?: boolean;
}

const DaySelector: React.FC<DaySelectorProps> = ({ value = [], onChange, disabled = false }) => {
  const weekdays = [
    { index: 0, label: 'Seg', fullName: 'Segunda-feira' },
    { index: 1, label: 'Ter', fullName: 'Terça-feira' },
    { index: 2, label: 'Qua', fullName: 'Quarta-feira' },
    { index: 3, label: 'Qui', fullName: 'Quinta-feira' },
    { index: 4, label: 'Sex', fullName: 'Sexta-feira' },
    { index: 5, label: 'Sáb', fullName: 'Sábado' },
    { index: 6, label: 'Dom', fullName: 'Domingo' },
  ];

  const toggleDay = (dayIndex: number) => {
    if (disabled) return;

    const newValue = value.includes(dayIndex)
      ? value.filter((d) => d !== dayIndex)
      : [...value, dayIndex].sort((a, b) => a - b);

    onChange(newValue);
  };

  return (
    <div className="day-selector">
      <div className="day-selector-buttons">
        {weekdays.map((day) => (
          <button
            key={day.index}
            type="button"
            className={`day-button ${value.includes(day.index) ? 'selected' : ''}`}
            onClick={() => toggleDay(day.index)}
            disabled={disabled}
            title={day.fullName}
          >
            {day.label}
          </button>
        ))}
      </div>
      <div className="day-selector-counter">
        {value.length === 0 ? (
          <span className="text-muted">Nenhum dia selecionado</span>
        ) : (
          <span className="text-primary">
            {value.length} {value.length === 1 ? 'dia' : 'dias'} por semana {value.length === 1 ? 'selecionado' : 'selecionados'}
          </span>
        )}
      </div>

      <style>{`
        .day-selector {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .day-selector-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .day-button {
          min-width: 50px;
          padding: 8px 12px;
          border: 2px solid #e0e0e0;
          border-radius: 6px;
          background-color: #fff;
          color: #666;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          user-select: none;
        }

        .day-button:hover:not(:disabled) {
          border-color: #2196f3;
          background-color: #f0f8ff;
          transform: translateY(-1px);
        }

        .day-button.selected {
          border-color: #2196f3;
          background-color: #2196f3;
          color: #fff;
          font-weight: 600;
        }

        .day-button.selected:hover:not(:disabled) {
          background-color: #1976d2;
          border-color: #1976d2;
        }

        .day-button:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .day-selector-counter {
          font-size: 14px;
          padding: 8px 0;
        }

        .text-muted {
          color: #999;
        }

        .text-primary {
          color: #2196f3;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default DaySelector;
